import { linkTargetResolver } from '@mntn-dev/app-routing'
import { Feed } from '@mntn-dev/ui-components'
import { ActivityContainer } from '../activity-container.tsx'
import { ActivityTrans } from '../activity-trans.tsx'
import { Link } from '../link.tsx'
import type { ActivityDetailsProps } from './types.ts'

export const ProjectOffersSent = ({
  activity,
  activity: {
    activityId,
    actor,
    details: {
      activityType,
      data: { target, offerIds },
    },
  },
  t,
  onNavigate,
  currentUrl,
}: ActivityDetailsProps<'project_offers_sent'>) => (
  <ActivityContainer {...{ activity }}>
    <Feed.Summary>
      <ActivityTrans
        t={t}
        i18nKey={`${activityType}.summary`}
        values={{
          subject: actor.displayName,
          project: { name: target.project.name },
          count: offerIds.length,
        }}
      />
    </Feed.Summary>
    <Feed.Annotations>
      <Feed.Tag
        type="notice"
        dataTestId={`activity-feed-item-${activityId}-status-tag`}
        dataTrackingId={`activity-feed-item-${activityId}-status-tag`}
      >
        {t(`${activityType}.status`)}
      </Feed.Tag>
      <Link
        {...{
          target: linkTargetResolver.project({ target }),
          t,
          onNavigate,
          currentUrl,
          dataTestId: `activity-feed-item-${activityId}-view-project-link`,
          dataTrackingId: `activity-feed-item-${activityId}-view-project-link`,
        }}
      />
    </Feed.Annotations>
  </ActivityContainer>
)
